// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function PortfolioAssetFromJSON(json) {
    return {
        'fundId': !exists(json, 'fundId') ? undefined : json['fundId'],
        'investorId': !exists(json, 'investorId') ? undefined : json['investorId'],
        'commitment': !exists(json, 'commitment') ? undefined : json['commitment'],
    };
}
export function PortfolioAssetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fundId': value.fundId,
        'investorId': value.investorId,
        'commitment': value.commitment,
    };
}
